import * as React from "react";
function TwitterColoredIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fill: "#1DA1F2",
    d: "M7.548 21.75c9.056 0 14.01-7.503 14.01-14.01 0-.213 0-.425-.015-.636A10.02 10.02 0 0024 4.555a9.815 9.815 0 01-2.828.775 4.94 4.94 0 002.165-2.724 9.864 9.864 0 01-3.127 1.196 4.929 4.929 0 00-8.391 4.49A13.98 13.98 0 011.67 3.148 4.928 4.928 0 003.195 9.72 4.88 4.88 0 01.96 9.105v.062a4.926 4.926 0 003.95 4.827 4.917 4.917 0 01-2.223.084 4.93 4.93 0 004.6 3.42A9.878 9.878 0 010 19.538a13.941 13.941 0 007.548 2.209"
  }));
}
const ForwardRef = React.forwardRef(TwitterColoredIcon);
export default ForwardRef;